module.exports = __webpack_public_path__ + "static/media/foreground--top.31f69cd1.svg";